// extracted by mini-css-extract-plugin
module.exports = {"container":"SX1l-RRFp7qWckqrTFnuv"};